import { render, staticRenderFns } from "./default_no_footer_kpmg.vue?vue&type=template&id=a8479a4c&scoped=true&lang=pug&"
import script from "./default_no_footer_kpmg.vue?vue&type=script&lang=js&"
export * from "./default_no_footer_kpmg.vue?vue&type=script&lang=js&"
import style0 from "./default_no_footer_kpmg.vue?vue&type=style&index=0&id=a8479a4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8479a4c",
  null
  
)

export default component.exports